module.exports = __webpack_public_path__ + "img/check-data-popup.0455c728.svg";